import { PropsWithChildren } from "react"

import { PhoneNumberDisplayFormatter } from "@shared/formatters/phoneNumberDisplayFormatter"
import { PhoneNumberPlainFormatter } from "@shared/formatters/phoneNumberPlainFormatter"
import { StringFormatter } from "@shared/formatters/stringFormatter"
import { PhoneNumber } from "@shared/types/phoneNumber"

import { DisplayPreferencesContext } from "./DisplayPreferencesContext"

// the formatters to be used in the provider
const defaultPhoneDisplayFormatter = new PhoneNumberDisplayFormatter()
const defaultPhoneLinkFormatter = new PhoneNumberPlainFormatter()

export interface DisplayPreferencesProviderProps extends PropsWithChildren {
  /**
   * The formatter to use for displaying a phone number to the user.
   */
  phoneDisplayFormatter?: StringFormatter<PhoneNumber>

  /**
   * The formatter to use a phone number as a link. Note that it doesn't
   * add a "tel:" protocol as phones can be used with other protocols.
   */
  phoneLinkFormatter?: StringFormatter<PhoneNumber>
}

/**
 *  This is the actual provider that will be used to provide the display preferences.
 */
export function DisplayPreferencesProvider({
  phoneDisplayFormatter = defaultPhoneDisplayFormatter,
  phoneLinkFormatter = defaultPhoneLinkFormatter,
  children,
}: DisplayPreferencesProviderProps) {
  return (
    <DisplayPreferencesContext.Provider
      value={{
        phoneDisplayFormatter,
        phoneLinkFormatter,
      }}
    >
      {children}
    </DisplayPreferencesContext.Provider>
  )
}
